export const APP_ENV = process.env.REACT_APP_ENV;
export const API_URL = process.env.REACT_APP_SERVER_URL;
export const ENCRYPTIION_PRIVATE_KEY = "8df234af7a1f14fa3cacf8733d5b236cd8afa0b4";
export const TOKEN_KEY = "token";

export const CMSWAGER_CONFIG = {
  BASE_URL: "https://cmssport.cmswager.com/",
  DEFAULT_LANG: "en-EN",
  CLIENT_KEY: "e1812eaf119585d380b4e77fb9090355",
};

export const BETBY_CONFIG = {
  operatorId: "2490629833483227138",
  brandId: "2490629937069957128",
  url: "https://ui.invisiblesport.com/bt-renderer.min.js",
  betbyAPI: "https://external-api.invisiblesport.com/api/v1/external_api/",
  themeName: "default", // will be provided when ready, until use
  operatorApi: "https://api.3ak3ek.com/betby/",
};
